import Order from "../../../entities/manhattan/order/Order";
import { IOrder } from "../../../entities/manhattan/order/types";
import { BasketFactory } from "../basket/BasketFactory";
import { IManhattanFactory } from "../types";

export const OrderFactory: IManhattanFactory = class OrderFactory {

  static create(order: IOrder, orderType: string) {
    return new Order(
      order.order,
      BasketFactory.create(order.basket),
      orderType
    );
  }

};
